import { IAuthenticatedUser } from './interfaces';

export function isUserWithUserGroup(
	user: IAuthenticatedUser,
	role: string,
): boolean {
	return !!user && user.groups && user.groups.includes(role);
}
